export default __webpack_public_path__ + "static/media/background-submenu.2ea71155.jpg";